import Cookies from 'js-cookie'
import { API } from '../../App';



export const getCountry = async (payload,token) => {
      let result
      try {
            result = await API.post("/country-list", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const CountryEdit = async (payload,token) => {
      let result
      try {
            result = await API.post("/edit-country", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
export const deleteCountry = async (payload,token) => {
      let result
      try {
            result = await API.post("/delete-country", payload, { headers: { authorization: `${token}` } })

      } catch (error) {
            console.log(error)
      }
      return result?.data
}
